import { TextSelection } from "prosemirror-state";
import React from "react";
import { EditorPopup } from "../../popup";
import { attrValueToDate, dateToAttrValue } from "../helpers";
import { DatePillPicker } from "./DatePillPicker";
export const DatePillPluginView = ({ view }) => {
    const selection = view.state.selection;
    const { node, from, to } = selection;
    if ((node === null || node === void 0 ? void 0 : node.type.name) !== "date_pill") {
        return null;
    }
    const { date } = node.attrs;
    const handleChange = (updatedDate) => {
        const tr = view.state.tr;
        view.dispatch(tr
            .setNodeMarkup(from, null, {
            ...node.attrs,
            date: dateToAttrValue(updatedDate),
        })
            .setSelection(TextSelection.near(tr.doc.resolve(to)))
            .scrollIntoView());
        view.focus();
    };
    return (React.createElement(EditorPopup, { view: view, referenceElement: view.nodeDOM(from), placement: "bottom" },
        React.createElement(DatePillPicker, { value: attrValueToDate(date), onChange: handleChange })));
};
